import { T, Translate } from '../../i18n';
import { m } from '../../mithril';

export const TagNameInputConfirmationContent = {
	view(collectionCount: number, oldName: string, newName: string) {
		return m('div', [
			m('p', Translate(T.TAG_EXISTS, newName)),
			m('span', Translate(T.TAG_MERGE_CONFIRM, { collectionCount, oldName, newName })),
		]);
	},
};
